/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'prettyPrintMaterialNumber',
    standalone: false
})
export class PrettyPrintMaterialNumberPipe implements PipeTransform {

    transform(reference: { number: string, description: string }): string {
        return reference ? `${reference.number} - ${reference.description}` : null;
    }
}
